<template>
  <form
    class="cg-form"
    novalidate
    v-bind="$attrs"
    @submit.prevent="(e) => $emit('submit', e)"
  >
    <slot />
  </form>
</template>

<script lang="ts">
import Vue from 'vue';
import CgInput from '../CgInput';

type ValidatableInstance = InstanceType<typeof CgInput>

export default Vue.extend({
  name: 'CgForm',
  methods: {
    getValidatableInputs(): ValidatableInstance[] {
      const inputs = this.$children as ValidatableInstance[]
      return inputs.filter((input) => typeof input?.validate === 'function')
    },
    /** @public */
    validate(): boolean {
      const inputs = this.getValidatableInputs()
      return inputs.filter((input) => !input?.validate()).length === 0
    },
    /** @public */
    resetValidation(): void {
      const inputs = this.getValidatableInputs()
      inputs.forEach((input) => input?.resetValidation())
    },
  },
});
</script>
